import { Instance } from 'mobx-state-tree';
import { RouteTerritoryDtoModelBase } from './RouteTerritoryDtoModel.base';

/* The TypeScript type of an instance of RouteTerritoryDtoModel */
export interface RouteTerritoryDtoModelType extends Instance<typeof RouteTerritoryDtoModel.Type> {}

/* A graphql query fragment builders for RouteTerritoryDtoModel */
export { selectFromRouteTerritoryDto, routeTerritoryDtoModelPrimitives, RouteTerritoryDtoModelSelector } from './RouteTerritoryDtoModel.base';

/**
 * RouteTerritoryDtoModel
 */
export const RouteTerritoryDtoModel = RouteTerritoryDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
